/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelTypeEnum } from './ModelTypeEnum';
import { ModelTypeEnumFromJSON, ModelTypeEnumFromJSONTyped, ModelTypeEnumToJSON } from './ModelTypeEnum';

/**
 *
 * @export
 * @interface PatchedQuestionnaireAnswerCreate
 */
export interface PatchedQuestionnaireAnswerCreate {
  /**
   *
   * @type {number}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  aiModel?: number;
  /**
   *
   * @type {number}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  datasetPipeline?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  selectedRiskMetrics?: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  styleCriteria?: Array<number>;
  /**
   *
   * @type {ModelTypeEnum}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  modelType?: ModelTypeEnum | null;
  /**
   *
   * @type {number}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  protectedGroupDataset?: number | null;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  performanceMetrics?: Array<number>;
  /**
   *
   * @type {number}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  reportType?: number | null;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  insightfulnessCriteria?: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedQuestionnaireAnswerCreate
   */
  personalDataExposureCategories?: Array<number>;
}

/**
 * Check if a given object implements the PatchedQuestionnaireAnswerCreate interface.
 */
export function instanceOfPatchedQuestionnaireAnswerCreate(value: object): value is PatchedQuestionnaireAnswerCreate {
  return true;
}

export function PatchedQuestionnaireAnswerCreateFromJSON(json: any): PatchedQuestionnaireAnswerCreate {
  return PatchedQuestionnaireAnswerCreateFromJSONTyped(json, false);
}

export function PatchedQuestionnaireAnswerCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedQuestionnaireAnswerCreate {
  if (json == null) {
    return json;
  }
  return {
    aiModel: json['ai_model'] == null ? undefined : json['ai_model'],
    datasetPipeline: json['dataset_pipeline'] == null ? undefined : json['dataset_pipeline'],
    selectedRiskMetrics: json['selected_risk_metrics'] == null ? undefined : json['selected_risk_metrics'],
    styleCriteria: json['style_criteria'] == null ? undefined : json['style_criteria'],
    modelType: json['model_type'] == null ? undefined : ModelTypeEnumFromJSON(json['model_type']),
    protectedGroupDataset: json['protected_group_dataset'] == null ? undefined : json['protected_group_dataset'],
    performanceMetrics: json['performance_metrics'] == null ? undefined : json['performance_metrics'],
    reportType: json['report_type'] == null ? undefined : json['report_type'],
    insightfulnessCriteria: json['insightfulness_criteria'] == null ? undefined : json['insightfulness_criteria'],
    personalDataExposureCategories:
      json['personal_data_exposure_categories'] == null ? undefined : json['personal_data_exposure_categories'],
  };
}

export function PatchedQuestionnaireAnswerCreateToJSON(value?: PatchedQuestionnaireAnswerCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    ai_model: value['aiModel'],
    dataset_pipeline: value['datasetPipeline'],
    selected_risk_metrics: value['selectedRiskMetrics'],
    style_criteria: value['styleCriteria'],
    model_type: ModelTypeEnumToJSON(value['modelType']),
    protected_group_dataset: value['protectedGroupDataset'],
    performance_metrics: value['performanceMetrics'],
    report_type: value['reportType'],
    insightfulness_criteria: value['insightfulnessCriteria'],
    personal_data_exposure_categories: value['personalDataExposureCategories'],
  };
}
